export const getUserAgreementLink = (userAgreement: AgreementVersion) => {
    if (userAgreement.translations?.length) {
        const translatedTermsAndConditions =
            userAgreement.translations.find((prop) => prop.field === 'link')?.value;

        return translatedTermsAndConditions || userAgreement.link;
    }

    return userAgreement.link;
};